export class Plan {
    Id_Plan: number;
    FullName: string;
    Id_Profile: number;
    ProfileName: string;
    NWeek: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/plan-model.ts